export enum AgencyCampaignsStatus {
  Registered = 'Registered',
  ProcessingSetup = 'Processing Setup',
  Active = 'Active',
  Inactive = 'Inactive',
  Denied = 'Denied',
}
